import memoize from 'memoize-one';
import publicRoutes from './public';
import privateRoutes from './private';

// eslint-disable-next-line react/prop-types
export default memoize((context) => [
  ...publicRoutes(context),
  ...privateRoutes(context)
]);
